import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from '@/shared/contexts/AuthContext'
import { UnitProvider } from '@/modules/units/contexts/UnitContext'
import { TranslationProvider } from '@/shared/contexts/TranslationContext'
import { ThemeProvider } from '@/shared/contexts/ThemeContext'

// Pages
import Home from '@/app/pages/Home'
import Login from '@/app/pages/Login'
import Signup from '@/app/pages/Signup'
import ForgotPassword from '@/app/pages/ForgotPassword'
import ResetPassword from '@/app/pages/ResetPassword'
import Dashboard from '@/app/pages/Dashboard'
import Profile from '@/modules/profile/ProfilePage'
import Onboarding from '@/app/pages/Onboarding'
import Units from '@/modules/units/UnitsPage'
import UnitEdit from '@/modules/units/UnitEditPage'
import { UnitMembersPage as UnitMembers } from '@/modules/units/team'
import BillingLayout from '@/modules/billing/Layout'
import PricingLayout from '@/modules/pricing/Layout'
import PoultryLayout from '@/modules/poultry/Layout'
import AccountingLayout from '@/modules/accounting/Layout'
import RegistrationsLayout from '@/modules/registrations/Layout'

function App() {
  return (
    <AuthProvider>
      <UnitProvider>
        <TranslationProvider>
          <ThemeProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/onboarding" element={<Onboarding />} />
              <Route path="/units" element={<Units />} />
              <Route path="/units/:unitId/edit" element={<UnitEdit />} />
              <Route path="/units/:unitId/members" element={<UnitMembers />} />
              {/* <Route path="/assets/*" element={<AssetsLayout />} /> */}
              <Route path="/billing/*" element={<BillingLayout />} />
              <Route path="/pricing/*" element={<PricingLayout />} />
              <Route path="/poultry/*" element={<PoultryLayout />} />
              <Route path="/accounting/*" element={<AccountingLayout />} />
              <Route path="/registrations/*" element={<RegistrationsLayout />} />
            </Routes>
          </ThemeProvider>
        </TranslationProvider>
      </UnitProvider>
    </AuthProvider>
  )
}

export default App
